// let domen = 'api.ksrs.ru';
let domen = 'api.kcsni-service.ru';
let https = 'https';

if (process.env.NODE_ENV === 'development') {
  domen = '127.0.0.1:8001';
  https = 'http';
}

export const DOMEN = `${https}://${domen}`;
export const AUTH_URL = `${https}://${domen}/accounts/`;
export const USER_URL = `${https}://${domen}/api/users/`;

